<template>
  <div class="pneu-avaria ml-4 mr-4">
    <b-form>
      <b-row>
        <!-- -->

        <b-col cols="1">
          <br />
          <b-button
            variant="warning"
            class="ml-5 mt-2"
            v-b-modal.modal-multi-avaria
            @click="reset()"
            >Novo</b-button
          >
        </b-col>
      </b-row>
    </b-form>

    <div class="d-flex justify-content-center mb-3"></div>
    <!--tbl de dados -->
    <b-table
      id="avaria"
      small
      hover
      striped
      sticky-header="818px"
      :items="avaria"
      :fields="fields"
    >
      <template slot="cell(actions)" slot-scope="data">
        <b-button
          @click="editavaria(data.item)"
          title="Editar avaria"
          size="sm"
          variant="primary"
          class="mr-2 mt-2"
          v-b-modal.modal-multi-avaria
        >
          <i class="fa fa-exclamation-circle"></i>
        </b-button>
      </template>
    </b-table>

    <!--  MODAL GRAVAÇÃO RELACAO DA avaria pneu -->
    <!--  MODAL GRAVAÇÃO RELACAO DA avaria pneu -->
    <div>
      <b-modal
        id="modal-multi-avaria"
        hide-footer
        size="lg"
        title="Cadastro de avarias"
      >
        <!-- -->
        <div>
          <b-row>
            <b-col cols="8">
              <label for="input-filial">DANOS</label>
              <div>
                <b-form-select
                  id="fun-empresa"
                  v-model="ava.danos_id"
                  required
                  :options="danos"
                  class="mb-3"
                  text-field="danos"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="12">
              <label for="input-live">AVARIA</label>
              <b-form-input
                v-model="ava.avaria"
                placeholder="Digite a descrição do avaria"
              ></b-form-input>
            </b-col>
          </b-row>
          <input id="id-avaria" type="hidden" v-model="ava.id" />

          <b-button
            class="mt-3"
            variant="success"
            block
            @click="postmotivo(), reset()"
            >Gravar</b-button
          >
        </div>
      </b-modal>
    </div>
    <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
  </div>
</template>


<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import moment from "moment";
import { mapState } from "vuex";

export default {
  computed: { ...mapState(["user"]) },
  name: "Manutencaomotivo",

  data: function () {
    return {
      carregando: false,
      empresas: [],
      ava: {},
      avaria: [], // [] lista
      danos: [],

      //  barra_inicial: 0,
      //  barra_limite: 300000,

      fields: [
        { key: "empresa_id", label: "Empresa", sortable: true },
        { key: "id", label: "Id", sortable: true },
        { key: "danos", label: "Danos", sortable: true },
        { key: "avaria", label: "avaria", sortable: true },
        {
          key: "dt_cadastro",
          label: "Data Cadastro",
          sortable: true,
          formatter: (value, key, avaria) => {
            return moment(avaria.dt_cadastro)
              .format("DD/MM/YYYY - HH:mm")
              .replace("Data inválida", "-");
          },
        },
        {
          key: "dt_alteracao",
          label: "Data Alteracao",
          sortable: true,
          formatter: (value, key, avaria) => {
            return moment(avaria.dt_alteracao)
              .format("DD/MM/YYYY - HH:mm")
              .replace("Data inválida", "-");
          },
        },

        { key: "actions", label: "Ações" },
      ],
    };
  },

  components: {},
  methods: {
    loadEmpresa() {
      let params = {
        psg: this.user.psg,
        id_grupo_empresa: `${this.user.id_empresa}`,
      };

      const url = `${baseApiUrl}/ctr/empresa`;
      axios
        .get(url, { params })
        .then((res) => {
          this.empresas = res.data.map((emp) => {
            return {
              ...emp,
              value: emp.id_empresa,
              empresa: emp.nomeempresarial,
              id_filial_erp: emp.id_filial_erp,
            };
          });
        })
        .catch(showError);
    },

    loadDanos() {
      let params = {
        psg: this.user.psg,
        empresa_id: `${this.user.id_empresa}`,
      };
      const url = `${baseApiUrl}/pneu/danos`;
      axios
        .get(url, { params })
        .then((res) => {
          this.danos = res.data.map((emp) => {
            return { ...emp, value: emp.id, danos: emp.danos };
          });
        })
        .catch(showError);
    },

    loadavaria() {
      let params = {
        psg: this.user.psg,
        empresa_id: `${this.user.id_empresa}`,
        origem: "webcad",
      };
      const url = `${baseApiUrl}/pneu/avarias`;
      axios.get(url, { params }).then((res) => {
        this.avaria = res.data.map((ava) => {
          return { ...ava };
        });
      });
    },

    editavaria(ava) {
      this.ava = { ...ava };
      this.loadEmpresa();
    },

    postmotivo() {
      let corpo = {
        psg: this.user.psg,
        empresa_id: `${this.user.id_empresa}`,
        id_funcionario: `${this.user.id_funcionario}`,
        id: `${this.ava.id}`,
        avaria: `${this.ava.avaria}`,
        danos_id: `${this.ava.danos_id}`,
      };

      const url = `${baseApiUrl}/pneu/avarias`;

      axios
        .post(url, corpo)
        .then(() => {
          this.$toasted.global.defaultSuccess();
          this.reset(); //limpar os objetos valores
        })
        .catch(showError);
    },

    reset() {
      this.ava = {};
      this.avaria = [];
      this.loadavaria();
    },
  },

  mounted() {
    this.loadEmpresa();
    this.loadDanos();
    this.loadavaria(); //    se habilitado carrega o grid
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
#selecaostatusx {
  font-size: 0.7em;
}

#motivos {
  font-size: 0.9em;
  text-align: center;
}
</style>